import { useEffect, useState } from "react";

/**
 * Tracks whether the Next-Gen layout currently has dark mode enabled.
 *
 * Dark mode is toggled by adding `.dark` to `<html>` (see `ManifoldNextGenLayout`).
 * This hook subscribes to that class via a MutationObserver so any component —
 * including ones rendered into portals — can react to theme changes without
 * threading props through the tree.
 */
export const useIsDarkMode = (): boolean => {
  const [isDark, setIsDark] = useState(
    () => typeof document !== "undefined" && document.documentElement.classList.contains("dark")
  );

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setIsDark(document.documentElement.classList.contains("dark"));
    });
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"],
    });
    return () => observer.disconnect();
  }, []);

  return isDark;
};
